// extracted by mini-css-extract-plugin
export default {"containerModule":"ModulePage_containerModule__C0DIo","title":"ModulePage_title__QAByC","subTitle":"ModulePage_subTitle__5MXop","description":"ModulePage_description__zhxni"};